@use '../../../scss/utility';

$_notification-min-width: utility.wb-pixel-to-rem(360px);
$_notification-max-width: utility.wb-pixel-to-rem(512px);

:host {
  /** @prop --z-index: z-index of the component */
  --z-index: #{utility.$wb-z-index-notification-host};

  padding: var(--wb-spacing-xxs);
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  pointer-events: none;
  z-index: var(--z-index);
}

:host([position='bottom-start']) {
  align-items: flex-start;
}

:host([position='bottom-center']) {
  align-items: center;
}

:host([position='bottom-end']) {
  align-items: flex-end;
}

:host([position='top-start']) {
  align-items: flex-start;
  flex-direction: column-reverse;
}

:host([position='top-center']) {
  align-items: center;
  flex-direction: column-reverse;
}

:host([position='top-end']) {
  align-items: flex-end;
  flex-direction: column-reverse;
}

:host([position]) {
  ::slotted(.wb-notification) {
    position: absolute;
    box-shadow: var(--wb-shadow-l);
    margin-block-start: utility.wb-pixel-to-rem(8px);
  }
}

:host([position='top-start']),
:host([position='top-center']),
:host([position='top-end']) {
  ::slotted(.wb-notification:last-child) {
    margin-block-start: 0;
  }
}

::slotted(.wb-notification) {
  max-width: $_notification-max-width;
  min-width: $_notification-min-width;
  width: auto;
}

::slotted(.wb-notification.is-visible) {
  margin-block-end: 0;
}
